import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Tabs from '../Tabs';
import Config, { IConfigMethods } from './Config'
import Invoices, { IInvoicesMethods } from './Invoices'
import Stock from '../../model/Stock';
import AnimatedSaveButton from '../AnimatedSaveButton';
import MarketData from './MarketData';
import { saveMarketData, startSetStock } from '../../actions/CurrentStock'
import IMarketData from '../../model/IMarketData';
import moment from 'moment';
import Announcements from './Announcements'
import api, { getCombinedTicker } from '../../api/api';
import { uppercaseFirstLetter } from '../../util/util'
import ConfirmEx from '../ConfirmEx'
import AlertEx from '../AlertEx';
import ReportConfig from '../reportConfig/ReportConfig'
import * as Roles from '../../model/Roles';
import { IGlobalState } from '../../model/IGlobalState';
import NotesComponent from './notes/NotesComponent';
import { IAnnouncementsMethods } from './EditAnnouncement';
import EditAnnouncementComments from '../client/EditAnnouncementComments';
import EmailMarketingPage, { IEmailMarketingPageMethods } from './EmailMarketingPage';


interface IProps {
    stock?:Stock;
    tab?:string;
    subTab?:string;
}


const ConfigTabName:string = 'Config';
const MarketDataTabName:string = 'Market';
const EmailMarketingTabName:string = 'Email Marketing';
const AnnouncementsTabName:string = 'Announcements';
const ReportsTabName:string = 'Reports';
const InvoicesTabName:string = 'Invoices';
const NotesTabName:string = 'Notes';
const CommentsTabName:string = 'Comments';


const StockForm:React.FC<IProps> = (props:IProps) => {
    const newStock = { 
 
    } as Stock
    const user = useSelector((state: IGlobalState) => state.user)
    const defaultTab = user.roles.hasOwnProperty(Roles.Admin) ? ConfigTabName : ReportsTabName;
    const [ stock, setStock ] = useState(props.stock || newStock)
    const [ marketData, setMarketData ] = useState(props.stock != null ? props.stock.currentMarketData : {} as IMarketData)
    const [ activeTab, setActiveTab ] = useState(uppercaseFirstLetter(props.tab) || defaultTab)
    
    const invoicesPage = React.createRef<IInvoicesMethods>();
    const announcementsPage = React.createRef<IAnnouncementsMethods>();
    const emailMarketingPage = React.createRef<IEmailMarketingPageMethods>();
    const configPage = React.createRef<IConfigMethods>();
    
    const dispatch = useDispatch();
   
    const save = async () : Promise<boolean> => {
        let success:boolean = false;
        if(activeTab === ConfigTabName){
            success = await configPage.current!.save();
        }else if(activeTab === MarketDataTabName){            
            await dispatch(saveMarketData(getCombinedTicker(stock!), marketData))
            success = true;
        }else if(activeTab === AnnouncementsTabName){
            success = await announcementsPage.current!.save();
        }else if(activeTab === EmailMarketingTabName){            
            success = await emailMarketingPage.current!.save();
        }else if(activeTab === InvoicesTabName){            
            await invoicesPage.current!.save();
            success = true;
        }
        return success;
    }

    


    

    const onMarketDataChange = (name:string, value:number|boolean) => {        
        const m1 = { ...marketData } as any;
        m1[name] = value;         
        setMarketData(m1)        
    }



   
    const setActiveTabState= (activeTab:string) => {
        
        setActiveTab(activeTab)

        const tokens = window.location.pathname.split('/');
        const sectionChanged = decodeURIComponent(tokens[3] || '') !== activeTab;

        if(sectionChanged){
            // Moving to a different section: set the section tab at index 3 and
            // drop any stale sub-tab segment (index 4+) from the previous section.
            const base = tokens.slice(0, 3);
            base.push(activeTab);
            window.history.replaceState( {} , document.title, base.join('/'));
        }else{
            // Same section (e.g. initial load / re-select): keep the sub-tab segment.
            tokens[3] = activeTab;
            window.history.replaceState( {} , document.title, tokens.join('/'));
        }

    }

    

   


    const onSavedAnnouncement = async () =>  {        
        
        dispatch(startSetStock(getCombinedTicker(stock)))                
    }

    const resyncAnnouncements = async ()  => {
        
        if (!await ConfirmEx('Please confirm you wish to resync Announcements'))
            return false;
        const result = await api().resyncAnnouncements(getCombinedTicker(stock));
        if(result.success){
            const s1 = { ...stock };
            s1.completedInitialPoll = false;             
            setStock(s1); 
            return true;
        }else{
            await AlertEx(result.errorMessage);
            return false;
        }
        
        
    }

    

    const existing = props.stock != null;
    const hasInvoiceRole = user.roles.hasOwnProperty(Roles.InvoiceTotal)
    const syncInProgress = existing && !stock.completedInitialPoll
    const showSaveButton =  activeTab !== NotesTabName && activeTab !== ReportsTabName && 
     (!props.stock || stock.completedInitialPoll)
     const created = props.stock && props.stock.created && `Created: ${moment(props.stock.created).format('DD MMM YY')}`;
    return (
        <div className="stockPage">
            <div className="space-between">
                <div className="space-between">
                <h1 title={created}> {props.stock ? `${props.stock.ticker}:${props.stock.exchange}` : 'Add New Stock'} </h1>
                { existing && !!props.stock!.managedBy.length && <span className='managed-by'>Managed by {props.stock!.managedBy.join(', ')} </span>}
                </div>
                { syncInProgress && <p className="sync">
                    Sync in Progress</p>}
                {showSaveButton && <AnimatedSaveButton onClick={save}  />} 
            </div>
            
            
                
                { user.roles.hasOwnProperty(Roles.Admin) && <>
                
                <Tabs onTabChanged={setActiveTabState} activeTab={activeTab}>

                    <div data-label={ConfigTabName}>
                        <Config 
                        id={stock.id}                    
                        ticker={stock.ticker} 
                        exchange={stock.exchange}
                        ref={configPage}
                        />
                    </div>

                    {existing && <div data-label={MarketDataTabName}>
                        <MarketData marketData={marketData} onChange={onMarketDataChange} id={stock.id} />
                    </div>}
                    {existing && user.roles.hasOwnProperty(Roles.EditMailchimp) && <div data-label={EmailMarketingTabName}>
                        <EmailMarketingPage
                        ref={emailMarketingPage}
                        tab={props.subTab}
                        />
                    </div>}

                    {existing && <div data-label={AnnouncementsTabName}>
                        <Announcements
                            syncInProgress={syncInProgress}
                            ref={announcementsPage}
                            onSavedAnnouncement={onSavedAnnouncement}
                            resyncAnnouncements={resyncAnnouncements}
                        />
                    </div>}

                    {existing && hasInvoiceRole && <div data-label={InvoicesTabName}>
                        <Invoices ticker={getCombinedTicker(stock)} stockId={stock.id} ref={invoicesPage} />
                    </div>}

                    {existing && <div data-label={NotesTabName}>
                        <NotesComponent ticker={getCombinedTicker(stock)} stockId={stock.id} />
                    </div>}

                    { existing && <div data-label={ReportsTabName}>
                            <ReportConfig ticker={getCombinedTicker(stock)} />
                        </div>}

                   
                   
                     { existing && user.roles.hasOwnProperty(Roles.EditMailchimp) && <div data-label={CommentsTabName}>
                        <EditAnnouncementComments combinedTicker={getCombinedTicker(stock)}
                         
                         />
                         </div> }

                </Tabs>
                </>}
           
        </div>
    )
    
}




export default StockForm